/** Lot Biography — SeedTrac's lot stock card; the page lives at /warehouse/lot-biography. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { guardDesk } from "../-guard";

export const Route = createFileRoute("/_app/warehouse/$stage/lot-biography")({
  beforeLoad: ({ params }) => {
    guardDesk(params.stage);
    throw redirect({ to: "/warehouse/lot-biography" });
  },
});
